// extracted by mini-css-extract-plugin
export default {"user-avatar-form":"style_user-avatar-form__p5V+Y","user-avatar-info":"style_user-avatar-info__WpkJK"};